import React from "react";

const checkForEmptySampleEingabe = (e) => {
  console.log({ e });
  const sampleEingabe = document.getElementById("sample-eingabe");
  const selection = window.getSelection();

  if (selection.rangeCount > 0) {
    const range = selection.getRangeAt(0);
    const cursorPosition = range.startOffset;

    // Check if the cursor is at the beginning of the line
    const isAtBeginningOfLine = cursorPosition === 0;

    console.log("Cursor is at the beginning of the line:", isAtBeginningOfLine);
  }
  if (sampleEingabe.children.length === 1) {
    if (sampleEingabe.textContent === "" || isAtBeginningOfLine) {
      if (e.keyCode === 8) {
        e.preventDefault();
      }
    }
  }

  console.log({})
};

export default function TextEingabe(props) {
  return (
    <div id="outer-sample-eingabe">
      <div
        id="sample-eingabe"
        contentEditable={props.fontsLoaded ? true : false}
        suppressContentEditableWarning="true"
        tabIndex="0"
        onKeyDown={(e) => {
          checkForEmptySampleEingabe(e);
        }}
      >
        <div className="mk-child" id="remove">
          Dein Text
        </div>
      </div>
    </div>
  );
}
